import BaseSection from '@/sections/base'
import { prefersReducedMotion } from '@/core/utils/a11y'

// Media / video handling is provided by the GraphicCoverVideo component,
// which BaseSection initializes automatically from the graphic-cover markup.

const selectors = {
  scrollButton: '[data-scroll-next], [data-scroll-target]',
  header: '.header-layer'
}

export default class MediaSection extends BaseSection {
  static TYPE = 'media'

  constructor(container: HTMLElement) {
    super(container)

    this.onButtonClick = this.onButtonClick.bind(this)

    // Listeners live on elements inside the section, so they are garbage
    // collected when the section is removed from the DOM on navigation.
    this.qsa(selectors.scrollButton).forEach(btn => {
      btn.addEventListener('click', this.onButtonClick)
    })
  }

  onButtonClick(e: Event) {
    const btn = e.currentTarget as HTMLElement
    let target: HTMLElement | null = null

    if (btn.hasAttribute('data-scroll-next')) {
      target = this.parent.nextElementSibling as HTMLElement | null
    }
    else {
      const sel = btn.getAttribute('data-scroll-target')
      if (sel) target = document.querySelector<HTMLElement>(sel)
    }

    if (!target) return

    e.preventDefault()
    this.scrollToElement(target)
  }

  scrollToElement(el: HTMLElement) {
    const header = document.querySelector<HTMLElement>(selectors.header)
    const headerHeight = header ? header.offsetHeight : 0
    const top = el.getBoundingClientRect().top + window.scrollY - headerHeight

    window.scrollTo({
      top,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    })
  }
}
